import cn from 'classnames';
import styles from './Card.module.less';

interface Props {
	className?: string;
	children?: JSX.Element | JSX.Element[] | string;
	header?: JSX.Element | JSX.Element[] | string;
	footer?: JSX.Element | JSX.Element[] | string;
}

function Card({ className, children, header, footer }: Props) {
	return (
		<div className={cn(styles.card, className)}>
			{header && <div>{header}</div>}
			<div>{children}</div>
			{footer && <div>{footer}</div>}
		</div>
	);
}

export default Card;
